/* global axios */
import ApiClient from './ApiClient';

class TaskLabelsAPI extends ApiClient {
  constructor() {
    super('task_labels', { accountScoped: true });
  }

  list() {
    return axios.get(this.url);
  }

  create(payload) {
    return axios.post(this.url, payload);
  }

  update(id, payload) {
    return axios.patch(`${this.url}/${id}`, payload);
  }

  remove(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new TaskLabelsAPI();
